"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
// Import and re-export centralized types
const text_shadow_1 = require('./text-shadow.cjs');
/**
 * Parses a CSS backdrop-filter property string into structured components
 * Follows MDN specification: https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter
 * Currently only supports drop-shadow
 */
function parse(value) {
    if (!value || typeof value !== 'string') {
        return null;
    }
    const tokens = value.split(') ').map(token => token.trim());
    if (tokens.length === 0) {
        return null;
    }
    const parsedTokens = tokens.reduce((acc, token) => {
        const [filter, ...rest] = token.split('(');
        if (filter === 'drop-shadow') {
            const restString = rest.join('').replace(')', '');
            const shadow = (0, text_shadow_1.parseSingleShadow)(restString);
            return {
                ...acc,
                dropShadow: shadow,
            };
        }
        return acc;
    }, {});
    return parsedTokens;
}
/**
 * Converts a parsed backdrop-filter value back to CSS string representation
 * @param value - The parsed backdrop-filter value to stringify
 * @returns The CSS string representation of the backdrop-filter value
 * Currently only supports drop-shadow
 */
function toCSSValue(value) {
    if (!value) {
        return 'none';
    }
    const { dropShadow } = value;
    if (dropShadow) {
        return `drop-shadow(${(0, text_shadow_1.toCSSValue)({ shadows: [dropShadow] })})`;
    }
    return null;
}
